export default {
  finalize() {
    // JavaScript to be fired on the contact page

    /* global google */
    var map;
    var infowindow = new google.maps.InfoWindow();

    function initialize_gmap(bound, mapZoom) {
      var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

      var isDraggable = w > 480 ? true : false;

      var settings = {
       zoom: mapZoom,
       center: bound.getCenter(),
       scrollwheel: false,
       draggable: isDraggable,
       mapTypeControl: false,
       mapTypeControlOptions: {
         style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
       },
       navigationControl: false,
       navigationControlOptions: {
         style: google.maps.NavigationControlStyle.SMALL,
       },
       mapTypeId: google.maps.MapTypeId.ROADMAP,
      };

      map = new google.maps.Map(document.getElementById("map_canvas"), settings);

      var center;

      google.maps.event.addDomListener(map, 'idle', function() {
       center = map.getCenter();
      });
      google.maps.event.addDomListener(window, 'resize', function() {
       map.setCenter(center);
      });
    }

    function addMarker(point_lat, point_long, address, title, addressLabel, showMarker) {

      var point = new google.maps.LatLng(point_lat, point_long);

      var formattedAddress = address.split(' ').join('+');

      var contentString = '<div id="gmapContent" style="text-align:left;">' +
        '<h3><a href="https://www.google.com/maps/dir/?api=1&destination=' + formattedAddress + '" target="_blank">' + title + '</a></h3>' +
        '<div id="bodyContent"><p>' + addressLabel + '</p>' +
        '<a href="https://www.google.com/maps/dir/?api=1&destination=' + formattedAddress + '" target="_blank">' +
        '<i class="fa fa-external-link"></i> <strong>Get Directions</strong></a></div></div>';

      var companyMarker = new google.maps.Marker({
        position: point,
        map: map,
        title: title,
      });

      if( showMarker === true ) {
        infowindow.setContent(contentString);
        infowindow.open(map, companyMarker);
      }

      google.maps.event.addListener(companyMarker, 'click', function() {
        infowindow.setContent(contentString);
        infowindow.open(map, this);
      });

    }

    var locations = [];

    $('.location-map').each(function() {
      var location = [];
      location.push(parseFloat($(this).find('.map-data').find('.lat').data('lat')));
      location.push(parseFloat($(this).find('.map-data').find('.lng').data('lng')));
      location.push($(this).find('.map-data').find('.address').data('address'));
      location.push($(this).find('.map-data').find('.title').data('title'));
      location.push($(this).find('.map-data').find('.address-label').data('label'));
      locations.push(location);
    });

    if ($('#map_canvas').length) {
      var i;
      var showMarker = true;
      var mapZoom = $('.map-panel').find('.zoom').data('zoom');
      var offset = 0.00008 * (Math.pow(2, -mapZoom + 20));
      if( locations.length > 1 ) {
        showMarker = false;
        offset = 0;
      }
      var bound = new google.maps.LatLngBounds();
      for (i = 0; i < locations.length; i++) {
        bound.extend(new google.maps.LatLng((locations[i][0] + offset), locations[i][1]));
      }
      initialize_gmap(bound, mapZoom);
      for (i = 0; i < locations.length; i++) {
        addMarker(locations[i][0], locations[i][1], locations[i][2], locations[i][3], locations[i][4], showMarker);
      }
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/map.js